module.exports = __webpack_public_path__ + "img/f_25_07.8e1c530f.jpg";